import {
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { AuthService } from '@fuse/services/auth/auth.service';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';

import 'rxjs/add/operator/do';
export class JwtInterceptor implements HttpInterceptor {

    router;

    constructor(
        public auth: AuthService,
        private _router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                // do stuff with response if you want
                // console.log('Interception event:');
                // console.log(event);
                if (event.url) {
                    if (event.url.indexOf('notification') < 0) {
                        setTimeout(() => { this.auth.refreshToken(); }, 1500);
                    }
                }
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    // redirect to the login route
                    // or show a modal
                    console.log('Interception error status 401');
                    this._router.navigate(['/login']);
                }
                if (err.status === 403) {
                    // redirect to the login route
                    // or show a modal
                    console.log('Interception error status 403');
                    console.log('Back to login');
                    this._router.navigate(['/login']);
                }
                this.auth.errorCode = err.status;
            }
        });
    }
}
